/* RESPONSIBLE TEAM: team-ai-agent-2 */
import { EntityType } from 'embercom/models/data/entity-types';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';

export interface FinReferencedPersonalisedAttributesWireFormat {
  renderable_type: RenderableType;
}

export default class FinReferencedPersonalisedAttributes {
  readonly renderableType: RenderableType = RenderableType.FinReferencedPersonalisedAttributes;

  get creatingEntity() {
    return { type: EntityType.Bot, id: -1 };
  }

  static deserialize(): FinReferencedPersonalisedAttributes {
    return new FinReferencedPersonalisedAttributes();
  }
}
